import React from "react";
import { RegistrationSuccess } from "../../_static/SvgImages/RegistrationSuccess";
import { RegistrationSuccessPromo } from "../../_static/SvgImages/RegistrationSuccessPromo";
import { RegistrationSuccessRAF } from "../../_static/SvgImages/RegistrationSuccessRAF";

export const SuccessSymbol = ({ type }) => {
  switch (type) {
    case "raf":
      return <RegistrationSuccessRAF />;
    case "promo":
      return <RegistrationSuccessPromo />;
    default:
      return <RegistrationSuccess />;
  }
};
